/**
 * Витягує ініціали з людського імені/назви для плейсхолдер-аватара.
 *
 * Правила:
 * - одне слово → перша літера ("John" → "J", "LUMINA" → "L");
 * - два+ слова → перша літера першого + перша літера останнього ("John Doe" → "JD",
 *   "John Michael Doe" → "JD");
 * - порожнє/пробіли/undefined → "" (виклик трактує як fallback-стан).
 *
 * `Array.from` коректно ріже surrogate-пари; `toLocaleUpperCase` коректно піднімає
 * кирилицю (українські назви салонів).
 */
export function getInitials(name?: string | null): string {
  if (!name) {
    return "";
  }

  const parts = name.trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) {
    return "";
  }

  const first = firstChar(parts[0]);
  if (parts.length === 1) {
    return first.toLocaleUpperCase();
  }

  const last = firstChar(parts[parts.length - 1]);
  return (first + last).toLocaleUpperCase();
}

function firstChar(word: string): string {
  return Array.from(word)[0] ?? "";
}
